import { checkCardType } from '../hyphen'

export type IInputField = {
  isValid: boolean
  errorMsg: string
  value: string | string[]
  required: boolean
}

export type IUserInputData = {
  [key: string]: IInputField
}

export const createInputField = (value: string | string[], required: boolean): IInputField => ({
  isValid: true,
  errorMsg: '',
  value,
  required,
})

/*
input 종류별 유효성
*/
export const inputValidation = (type: string, input: string) => {
  switch (type) {
    case 'name':
      let nameReg = /^[가-힣]{2,10}$/
      if (input.length > 0 && !nameReg.test(input)) {
        const data = {
          isValid: false,
          errorMsg: '정확한 성명을 입력해 주세요',
          value: input,
        }
        return data
      } else {
        const data = {
          isValid: true,
          errorMsg: '',
          value: input,
        }
        return data
      }
    case 'phoneNumber':
      if (input.length > 0 && !input.includes('-')) {
        const data = {
          isValid: false,
          errorMsg: '정확한 전화번호를 입력해 주세요',
          value: input,
        }
        return data
      } else {
        const data = {
          isValid: true,
          errorMsg: '',
          value: input,
        }
        return data
      }
    case 'email':
      const emailReg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
      if (input.length < 1 || !emailReg.test(input)) {
        const data = {
          isValid: false,
          errorMsg: '이메일 형식을 확인해 주세요',
          value: input,
        }
        return data
      } else {
        const data = {
          isValid: true,
          errorMsg: '',
          value: input,
        }
        return data
      }
    case 'cardNumber':
      if (input.length > 0 && input.length !== checkCardType(input)) {
        const data = {
          isValid: false,
          errorMsg: '정확한 카드번호를 입력해 주세요',
          value: input,
        }
        return data
      } else {
        const data = {
          isValid: true,
          errorMsg: '',
          value: input,
        }
        return data
      }
    case 'cardExpiryDate':
      if (input.length > 0 && !input.includes('/')) {
        const data = {
          isValid: false,
          errorMsg: '정확한 유효기간을 입력해 주세요',
          value: input,
        }
        return data
      } else if (input.length >= 2 && Number(input.slice(0, 2)) > 12) {
        const data = {
          isValid: false,
          errorMsg: '정확한 유효기간을 입력해 주세요',
          value: input,
        }
        return data
      } else {
        const data = {
          isValid: true,
          errorMsg: '',
          value: input,
        }
        return data
      }
    case 'cardPassword':
      if (input.length === 1) {
        const data = {
          isValid: false,
          errorMsg: '정확한 비밀번호를 입력해 주세요',
          value: input,
        }
        return data
      } else {
        const data = {
          isValid: true,
          errorMsg: '',
          value: input,
        }
        return data
      }
    case 'registrationNumber':
      if (input.length > 0 && !input.includes('-')) {
        const data = {
          isValid: false,
          errorMsg: '정확한 사업자 번호를 입력해 주세요',
          value: input,
        }
        return data
      } else {
        const data = {
          isValid: true,
          errorMsg: '',
          value: input,
        }
        return data
      }
    case 'verifyCode':
      const verifyCodeReg = /^\d{6}$/
      if (input.length > 0 && !verifyCodeReg.test(input)) {
        const data = {
          isValid: false,
          errorMsg: '',
          value: input,
        }
        return data
      } else {
        const data = {
          isValid: true,
          errorMsg: '',
          value: input,
        }
        return data
      }
    case 'accountPassword':
      const accountPasswordReg =
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!\"#$%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~])[A-Za-z\d!\"#$%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]{8,}$/
      if (input.length > 0 && !accountPasswordReg.test(input)) {
        const data = {
          isValid: false,
          errorMsg: '8자리 이상의 숫자+영문자+특수문자',
          value: input,
        }
        return data
      } else {
        const data = {
          isValid: true,
          errorMsg: '',
          value: input,
        }
        return data
      }
    case 'membershipPassword':
      const membershipPasswordReg = /^\d{4,6}$/
      if (input.length > 0 && !membershipPasswordReg.test(input)) {
        const data = {
          isValid: false,
          errorMsg: '4-6자리 숫자 비밀번호',
          value: input,
        }
        return data
      } else {
        const data = {
          isValid: true,
          errorMsg: '',
          value: input,
        }
        return data
      }
    case 'CVC':
      const CVCReg = /^\d{3}$/
      if (input.length > 0 && !CVCReg.test(input)) {
        const data = {
          isValid: false,
          errorMsg: '3자리 CVC',
          value: input,
        }
        return data
      } else {
        const data = {
          isValid: true,
          errorMsg: '',
          value: input,
        }
        return data
      }
    default: {
      const data = {
        isValid: true,
        errorMsg: '',
        value: input,
      }
      return data
    }
  }
}

/*
input disabled 판별 함수
*/
export const isInputValid = (userInputData: IUserInputData): boolean => {
  for (const key in userInputData) {
    const { required, value, isValid } = userInputData[key]
    if (!isValid) {
      return false
    } else if (required && (!value.length || !isValid)) {
      return false
    }
  }
  return true
}
